import {trans} from '@frontend/helpers'
import {useUserData} from '@frontend/hooks'
import {FavouritesApi} from '@frontend/modules/private/favourites/FavouritesApi'
import {useAuthStore} from '@frontend/stores'
import {
    mdiHeart,
    mdiHeartOutline,
} from '@mdi/js'
import clsx from 'clsx'
import {
    useEffect,
    useState,
} from 'react'
import {IconButton} from 'swayok-react-mdb-ui-kit/components/Icon/IconButton'
import {handleErrorResponse} from 'swayok-react-mdb-ui-kit/helpers/api/ApiRequestErrorHelpers'
import type {ApiError} from 'swayok-react-mdb-ui-kit/services/ApiRequestService'
import {ToastService} from 'swayok-react-mdb-ui-kit/services/ToastService'
import type {TextColors} from 'swayok-react-mdb-ui-kit/types/Common'
import type {ServiceLikeButtonIconProps} from '../../../ads/AdsModuleTypes'

// Кнопка добавления/удаления исполнителя услуг в избранное.
export function ServiceLikeIconButton(props: ServiceLikeButtonIconProps) {

    const {
        executor,
        // Нельзя использовать напрямую, поэтому переименовываем.
        isFavourite: propsValue,
        white,
        noLabel,
        filled,
        disabled,
        className,
        onFavoriteStateChange,
    } = props

    const isLoggedIn: boolean = !!useUserData()
    const initUserAuthModal = useAuthStore(
        state => state.initUserAuthModal
    )

    // Хранение состояния без необходимости перезагрузки списка услуг.
    const [
        isLiked,
        setIsLiked,
    ] = useState<boolean>(propsValue)

    // Состояние отправки запроса в API.
    const [
        isProcessing,
        setIsProcessing,
    ] = useState<boolean>(false)

    // Изменение состояния после обновления данных услуги
    // или входа/выхода пользователя.
    useEffect(() => {
        setIsLiked(propsValue && isLoggedIn)
    }, [propsValue, isLoggedIn])

    // Добавление/удаление из избранного.
    const saveFavoriteState = (newValue: boolean) => {
        if (!isLoggedIn) {
            initUserAuthModal()
            return
        }
        if (isProcessing) {
            return
        }
        setIsProcessing(true)
        setIsLiked(newValue)
        FavouritesApi.changeStateForExecutor(executor.id, newValue)
            .then(() => {
                onFavoriteStateChange?.(newValue)
                ToastService.success(
                    newValue
                        ? trans().services.messages.service_like_added
                        : trans().services.messages.service_like_removed
                )
            })
            .catch((error: ApiError) => {
                setIsLiked(!newValue)
                handleErrorResponse(error)
            })
            .finally(() => {
                setIsProcessing(false)
            })
    }

    let label: string | undefined
    if (!noLabel) {
        label = isLiked
            ? trans().ads.remove_like
            : trans().ads.add_like
    }

    let iconColor: TextColors = ''
    let buttonClass: string = ''
    if (isProcessing) {
        iconColor = 'muted'
        buttonClass = 'disabled'
    } else if (isLiked) {
        iconColor = 'red'
        buttonClass = 'active'
    } else if (white) {
        iconColor = 'white'
    }

    let tooltip: string | undefined
    if (noLabel && !isProcessing) {
        tooltip = isLiked
            ? trans().ads.remove_like
            : trans().ads.add_like
    }

    return (
        <IconButton
            path={isLiked || filled ? mdiHeart : mdiHeartOutline}
            className={clsx(className, buttonClass)}
            color={iconColor}
            onClick={event => {
                event.preventDefault()
                event.stopPropagation()
                saveFavoriteState(!isLiked)
            }}
            disabled={disabled || isProcessing}
            label={label}
            tooltip={tooltip}
        />
    )
}
